import React from 'react'
import { Table } from 'react-bootstrap'
import ScreenshotPlaceholder from '../../../components/ScreenshotPlaceholder'
import { Tip, Warn, Code, ArticleLink, Ext, TemplateBtn } from '../_helpers'

export const SECTION_ARTICLES = [
  {
    id: 'results-glossary',
    category: 'results',
    title: 'Γλωσσάριο — ενεργειακοί όροι σε απλή γλώσσα',
    summary: 'Κάθε όρος που εμφανίζεται στα γραφήματα αποτελεσμάτων και στις κάρτες KPI, σε ένα μέρος.',
    body: (
      <>
        <p>Τα υπόλοιπα άρθρα αυτής της ενότητας παραπέμπουν εδώ. Αποθηκεύστε το ως γρήγορη αναφορά.</p>

        <Table bordered size="sm" responsive className="small">
          <thead style={{ background: 'var(--color-neutral-100)' }}>
            <tr><th>Όρος</th><th>Τι σημαίνει</th></tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>kWh</strong> (κιλοβατώρα)</td>
              <td>Μονάδα <em>ενέργειας</em>. Ένα kWh ≈ ένας θερμαντήρας ανεμιστήρα που λειτουργεί για μία ώρα. Οι λογαριασμοί μετράται σε kWh.</td>
            </tr>
            <tr>
              <td><strong>kW</strong> (κιλοβάτ)</td>
              <td>Μονάδα <em>ισχύος</em> — πόσο γρήγορα καταναλώνεται ενέργεια αυτή τη στιγμή. Ένας βραστήρας 2 kW για μισή ώρα καταναλώνει 1 kWh.</td>
            </tr>
            <tr>
              <td><strong>Μέγιστη ζήτηση</strong></td>
              <td>Η υψηλότερη ισχύς (kW) που αντλήθηκε σε μια περίοδο. Τα τέλη δικτύου συνδέονται συχνά με αυτόν τον αριθμό.</td>
            </tr>
            <tr>
              <td><strong>Παραγωγή</strong></td>
              <td>Ηλεκτρική ενέργεια που παράγεται από τα ηλιακά πάνελ, ανεμογεννήτριες κ.λπ.</td>
            </tr>
            <tr>
              <td><strong>Φορτίο / κατανάλωση</strong></td>
              <td>Ηλεκτρική ενέργεια που χρησιμοποιείται από κτίρια και εξοπλισμό.</td>
            </tr>
            <tr>
              <td><strong>Αυτοκατανάλωση (%)</strong></td>
              <td>Από όλη την ενέργεια <em>που παράγατε</em>, τι ποσοστό χρησιμοποιήσατε οι ίδιοι
                (αντί να την εξάγετε). Υψηλό = σπαταλάτε λιγότερο από την παραγωγή σας.</td>
            </tr>
            <tr>
              <td><strong>Αυτάρκεια (%)</strong></td>
              <td>Από όλη την ενέργεια <em>που καταναλώσατε</em>, τι ποσοστό προήλθε από τη δική σας παραγωγή.
                Υψηλό = εξαρτάστε λιγότερο από το δίκτυο.</td>
            </tr>
            <tr>
              <td><strong>Κοινόχρηστη ενέργεια</strong> <em>(έννοια)</em></td>
              <td>Ενέργεια που παράγεται από ένα μέλος κοινότητας και καταναλώνεται εντός της ίδιας ώρας από
                άλλο μέλος. Πολλά εθνικά προγράμματα ανταμείβουν αυτό. Η πλατφόρμα δεν εμφανίζει αυτό
                ως ξεχωριστό KPI αυτή τη στιγμή — εμφανίζεται έμμεσα μέσω της αυτοκατανάλωσης και του
                γραφήματος Ενεργειακού Ισοζυγίου.</td>
            </tr>
            <tr>
              <td><strong>Εισαγωγή / εξαγωγή</strong></td>
              <td>Εισαγωγή = ηλεκτρική ενέργεια που αντλείται από το δίκτυο. Εξαγωγή = ηλεκτρική ενέργεια που αποστέλλεται στο δίκτυο.</td>
            </tr>
            <tr>
              <td><strong>Τιμολόγιο</strong></td>
              <td>Η τιμή της ηλεκτρικής ενέργειας, σε €/kWh, που συχνά μεταβάλλεται ανά ώρα.</td>
            </tr>
            <tr>
              <td><strong>Κατάσταση φόρτισης (SOC)</strong></td>
              <td>Πόσο φορτισμένη είναι μια μπαταρία, από 0% (άδεια) έως 100% (πλήρης).</td>
            </tr>
            <tr>
              <td><strong>NPV</strong> (Καθαρή Παρούσα Αξία)</td>
              <td>Η συνολική αξία μιας επένδυσης κατά τη διάρκεια ζωής της, σε σημερινές τιμές. <strong>Θετικό = κερδοφόρο</strong>· αρνητικό = ζημιά.</td>
            </tr>
            <tr>
              <td><strong>IRR</strong> (Εσωτερικός Βαθμός Απόδοσης) <em>(έννοια)</em></td>
              <td>Η ετήσια ποσοστιαία απόδοση της επένδυσης. Τα αποτελέσματα CBA της πλατφόρμας
                εμφανίζουν αυτή τη στιγμή NPV, BCR, αποπληρωμή, ετήσιες εξοικονομήσεις και CO₂ — όχι απευθείας το IRR — αλλά
                ο όρος εμφανίζεται στην περιγραφή του εργαλείου.</td>
            </tr>
            <tr>
              <td><strong>BCR</strong> (Λόγος Οφέλους-Κόστους)</td>
              <td>Συνολικά οφέλη διαιρεμένα με συνολικά κόστη. Πάνω από 1 = η επένδυση αποσβένεται.</td>
            </tr>
            <tr>
              <td><strong>Αποπληρωμή (έτη)</strong></td>
              <td>Πόσα χρόνια εξοικονομήσεων χρειάζονται για να καλυφθεί το αρχικό κόστος.</td>
            </tr>
            <tr>
              <td><strong>MAPE</strong> (Μέσο Απόλυτο Ποσοστιαίο Σφάλμα)</td>
              <td>Σφάλμα πρόβλεψης. Χαμηλότερο είναι καλύτερο — π.χ. ένα MAPE 10% σημαίνει ότι οι προβλέψεις αποκλίνουν κατά
                10% κατά μέσο όρο.</td>
            </tr>
            <tr>
              <td><strong>GHI</strong></td>
              <td>Ολική Οριζόντια Ακτινοβολία — συνολικό ηλιακό φως που προσπίπτει σε επίπεδη επιφάνεια, σε W/m². Η κύρια μετεωρολογική είσοδος για ηλιακές προβλέψεις.</td>
            </tr>
          </tbody>
        </Table>
      </>
    ),
  },

  // =========================================================================
  {
    id: 'results-forecast',
    category: 'results',
    title: 'Ανάγνωση του γραφήματος πρόβλεψης',
    summary: 'Τι σημαίνουν η γραμμή, η σκιασμένη ζώνη και ο αριθμός ακρίβειας.',
    body: (
      <>
        <p>
          Ένα αποτέλεσμα πρόβλεψης έχει τρία μέρη: μια <strong>γραμμή ιστορικού</strong>, μια
          {' '}<strong>προβλεπόμενη γραμμή</strong> και μια <strong>σκιασμένη ζώνη</strong> γύρω από την
          πρόβλεψη που δείχνει το εύρος αβεβαιότητάς της.
        </p>
        <ScreenshotPlaceholder
          img="forecast-results.png"
          description="A finished forecast — line for past data, a forecast line, and a shaded band around the prediction. A MAPE value and a Confidence level badge (LOW / MEDIUM / MEDIUM-HIGH / HIGH) are shown alongside."
          source="Platform — Forecasting page, after a successful run. Capture the result panel on the right: chart + the MAPE/Confidence indicators. (A community with uploaded load data is needed.)"
          caption="Ένα τυπικό αποτέλεσμα πρόβλεψης."
        />

        <ul>
          <li><strong>Γραμμή ιστορικού</strong> — αυτό που πράγματι συνέβη. Χρησιμοποιήστε την για να ελέγξετε ότι τα δεδομένα εισόδου φαίνονται σωστά.</li>
          <li><strong>Γραμμή πρόβλεψης</strong> — η καλύτερη μεμονωμένη εκτίμηση του μοντέλου για το μέλλον.</li>
          <li><strong>Σκιασμένη ζώνη</strong> — ένα εύρος όπου είναι πιθανό να πέσει η πραγματική τιμή. Μια <em>στενή</em> ζώνη σημαίνει ότι το μοντέλο είναι σίγουρο· μια <em>πλατιά</em> ζώνη σημαίνει αβεβαιότητα (συχνό σε μεγάλους ορίζοντες ή με λίγα δεδομένα εισόδου).</li>
        </ul>

        <h5 className="mt-3">Δύο δείκτες ακρίβειας</h5>
        <p>
          Η πλατφόρμα εμφανίζει δύο συνοπτικούς δείκτες δίπλα σε κάθε πρόβλεψη — διαβάστε τους μαζί:
        </p>

        <p className="mb-1"><strong>1. Επίπεδο εμπιστοσύνης</strong> — μια ενιαία ετικέτα με μία από τέσσερις τιμές:</p>
        <Table bordered size="sm" className="small">
          <thead style={{ background: 'var(--color-neutral-100)' }}>
            <tr><th>Ετικέτα</th><th>Σημασία</th></tr>
          </thead>
          <tbody>
            <tr><td><strong>HIGH</strong></td><td>Άφθονα καθαρά δεδομένα εισόδου· τα αποτελέσματα είναι κατάλληλα για επιχειρησιακές αποφάσεις.</td></tr>
            <tr><td><strong>MEDIUM-HIGH</strong></td><td>Καλό. Χρήσιμο για σχεδιασμό.</td></tr>
            <tr><td><strong>MEDIUM</strong></td><td>Αποδεκτά αλλά ατελή δεδομένα εισόδου — επαληθεύστε πριν ενεργήσετε σε οριακές περιπτώσεις.</td></tr>
            <tr><td><strong>LOW</strong></td><td>Περιορισμένα δεδομένα εισόδου ή αδύναμο σήμα. Αντιμετωπίστε την πρόβλεψη ως ενδεικτική· προσθέστε περισσότερο ιστορικό.</td></tr>
          </tbody>
        </Table>

        <p className="mt-3 mb-1"><strong>2. MAPE</strong> (Μέσο Απόλυτο Ποσοστιαίο Σφάλμα) — η μέση απόκλιση μεταξύ πρόβλεψης και πραγματικότητας, σε %. Κατά προσέγγιση οδηγός του κλάδου:</p>
        <Table bordered size="sm" className="small">
          <thead style={{ background: 'var(--color-neutral-100)' }}>
            <tr><th>MAPE</th><th>Σημασία</th></tr>
          </thead>
          <tbody>
            <tr><td>&lt; 10%</td><td>Πολύ καλό.</td></tr>
            <tr><td>10 – 20%</td><td>Καλό. Χρήσιμο για σχεδιασμό και βελτιστοποίηση.</td></tr>
            <tr><td>20 – 35%</td><td>Αποδεκτό για πρώιμο στάδιο. Προσθέστε δεδομένα ή μετεωρολογικά στοιχεία για βελτίωση.</td></tr>
            <tr><td>&gt; 35%</td><td>Αντιμετωπίστε ως ενδεικτικό. Δείτε <ArticleLink to="tb-forecast-flat">«Η πρόβλεψή μου φαίνεται επίπεδη ή λανθασμένη»</ArticleLink>.</td></tr>
          </tbody>
        </Table>

        <Tip>
          Οι ηλιακές προβλέψεις είναι συνήθως πιο ακριβείς από τις προβλέψεις φορτίου επειδή το ηλιακό φως είναι πιο
          προβλέψιμο. Η προσθήκη αρχείου μετεωρολογικών δεδομένων μειώνει περαιτέρω το ηλιακό MAPE — δείτε
          {' '}<ArticleLink to="data-weather">Αρχεία μετεωρολογικών δεδομένων</ArticleLink>.
        </Tip>
      </>
    ),
  },

  // =========================================================================
  {
    id: 'results-optimisation-kpis',
    category: 'results',
    title: 'Ανάγνωση των KPI βελτιστοποίησης',
    summary: 'Τι σημαίνει κάθε κάρτα στο Σύνοψη KPI μετά από μια εκτέλεση Βελτιστοποίησης.',
    body: (
      <>
        <p>
          Μετά από μια εκτέλεση βελτιστοποίησης, εμφανίζεται μια <strong>Σύνοψη KPI</strong> πάνω από τα γραφήματα. Οι
          κάρτες που εμφανίζονται εξαρτώνται από το αν η κοινότητά σας έχει μπαταρία και αν ήταν
          διαθέσιμο τιμολόγιο, αλλά το τυπικό σύνολο παρατίθεται παρακάτω.
        </p>
        <ScreenshotPlaceholder
          img="kpi-cards.png"
          description="The KPI Summary panel that appears after running an optimisation — cards for Daily Cost, Self-Sufficiency, Self-Consumption, Grid Import, Grid Import Cost, Grid Export Revenue, Peak Import and CO2 Avoided."
          source="Platform — Optimization page (titled 'Modelling'), after a successful run. Capture the KPI Summary row that appears above the charts."
          caption="Το πλαίσιο Σύνοψης KPI από το αποτέλεσμα βελτιστοποίησης."
        />

        <h5 className="mt-3">Κάθε KPI επεξηγημένο</h5>
        <Table bordered size="sm" responsive className="small">
          <thead style={{ background: 'var(--color-neutral-100)' }}>
            <tr><th>KPI</th><th>Τι σας λέει</th><th>Πώς να το βελτιώσετε</th></tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>Ημερήσιο Κόστος</strong></td>
              <td>Συνολικό κόστος λειτουργίας της κοινότητας για την βελτιστοποιημένη ημέρα (εισαγωγές μείον έσοδα εξαγωγής).</td>
              <td>Καλύτερα σήματα τιμολογίων, περισσότερα Φ/Β, μπαταρία διαστασιολογημένη στις ώρες αιχμής.</td>
            </tr>
            <tr>
              <td><strong>Αυτάρκεια (%)</strong></td>
              <td>«Από την ενέργεια που χρησιμοποίησα, πόση προήλθε από τη δική μου παραγωγή;»</td>
              <td>Προσθέστε περισσότερα Φ/Β· μειώστε την κατανάλωση· προσθέστε αποθήκευση.</td>
            </tr>
            <tr>
              <td><strong>Αυτοκατανάλωση (%)</strong></td>
              <td>«Από την ενέργεια που παρήγαγα, πόση χρησιμοποίησα ο ίδιος αντί να εξάγω;»</td>
              <td>Προσθέστε μπαταρία· μετατοπίστε ευέλικτα φορτία στις ηλιόλουστες ώρες.</td>
            </tr>
            <tr>
              <td><strong>Εισαγωγή από Δίκτυο (kWh)</strong></td>
              <td>Συνολική ενέργεια που αγοράστηκε από το δίκτυο εκείνη την ημέρα.</td>
              <td>Περισσότερα Φ/Β και αποθήκευση· ευέλικτα φορτία στις ηλιακές ώρες.</td>
            </tr>
            <tr>
              <td><strong>Κόστος Εισαγωγής Δικτύου</strong></td>
              <td>Τι κόστισαν οι εισαγωγές σε νόμισμα. Συνδυάζει όγκο × τιμολόγιο.</td>
              <td>Αποφύγετε εισαγωγές σε ώρες αιχμαίων τιμών· προφορτίστε από φθηνότερες ώρες.</td>
            </tr>
            <tr>
              <td><strong>Έσοδα Εξαγωγής Δικτύου</strong></td>
              <td>Τι πληρωθήκατε για τις εξαγωγές.</td>
              <td>Εξαρτάται από το σχήμα τιμολογίου εξαγωγής σας· δεν αποτελεί στόχο από μόνο του αν η αυτοκατανάλωση είναι προτιμητέα.</td>
            </tr>
            <tr>
              <td><strong>Αιχμή Εισαγωγής (kW)</strong></td>
              <td>Η υψηλότερη ανά ώρα άντληση δικτύου κατά τη διάρκεια της ημέρας. Τα τέλη δικτύου συνδέονται συχνά με αυτό.</td>
              <td>Κατανείμετε φορτία στο χρόνο· χρησιμοποιήστε μπαταρία για κοψίματα αιχμής.</td>
            </tr>
            <tr>
              <td><strong>CO2 που Αποφεύχθηκε (kg)</strong></td>
              <td>Εκπομπές που αποφεύχθηκαν σε σύγκριση με τη λήψη της ίδιας ενέργειας από το δίκτυο. Οδηγείται από αυτοκαταναλωθέντα Φ/Β/αιολική.</td>
              <td>Μεγιστοποιήστε την αυτοκατανάλωση· διαστασιολογήστε τα Φ/Β στο ημερήσιο φορτίο.</td>
            </tr>
          </tbody>
        </Table>

        <h5 className="mt-3">Αυτοκατανάλωση έναντι Αυτάρκειας — το πιο συχνά μπερδεμένο ζεύγος</h5>
        <p>Ακούγονται παρόμοια αλλά απαντούν σε αντίθετες ερωτήσεις:</p>
        <ul>
          <li><strong>Αυτοκατανάλωση</strong> αφορά <em>την παραγωγή σας</em>: πόσο από αυτό που παράγατε χρησιμοποιήσατε;</li>
          <li><strong>Αυτάρκεια</strong> αφορά <em>την κατανάλωσή σας</em>: πόσο από αυτό που χρησιμοποιήσατε παράγατε οι ίδιοι;</li>
        </ul>

        <h5 className="mt-3">Εύλογα εύρη ελέγχου</h5>
        <ul>
          <li>Μια κοινότητα με μέτρια μόνο Φ/Β Οροφής και χωρίς μπαταρία: αυτοκατανάλωση 60–90%, αυτάρκεια 10–25%.</li>
          <li>Μια κοινότητα με μεγάλο ηλιακό πάρκο και μπαταρία: η αυτάρκεια μπορεί να υπερβεί το 50%, αυτοκατανάλωση 80–95%.</li>
          <li>Αυτάρκεια πάνω από ~90% σημαίνει ότι μόλις εισάγετε — επαληθεύστε ότι το αρχείο φορτίου δεν είναι υποεκτιμημένο.</li>
        </ul>
        <Warn>
          Αν ένα KPI φαίνεται μη ρεαλιστικά καλό (π.χ. αυτάρκεια 99% με μέτρια μόνο Φ/Β), δείτε
          {' '}<ArticleLink to="tb-kpi-sanity-check">«Τα KPI μου φαίνονται πολύ καλά ή πολύ κακά»</ArticleLink>.
        </Warn>
      </>
    ),
  },
]
